// react
import React from 'react';

function ProductTabDescription(props) {
    const { product } = props;
    return (
        <div className="typography">
            <p>
                {product.description}
            </p>
        </div>
    );
}

export default ProductTabDescription;
